import { Component } from '@angular/core';
import { fadeInAnimation } from '../_animations/fade-in.animation';

@Component({
  selector: 'app-more-info',
  templateUrl: './more-info.component.html',
  animations: [ fadeInAnimation ]
})
export class MoreInfoComponent {
}
